import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { memo, useCallback } from "react";

export const MyLink = memo(
  (props: {
    to: string;
    text: string;
    icon: JSX.Element;
    close?: () => void;
    onClick?: () => void;
  }) => {
    const { to, text, icon, close, onClick } = props;
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });

    const onBtnClick = useCallback(() => {
      onClick && onClick();
      close && close();
    }, [onClick, close]);

    return (
      <ListItemButton component={Link} to={to} selected={match !== null} onClick={onBtnClick}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    );
  }
);
